<template>
  <v-navigation-drawer
    v-if="$vuetify.breakpoint.mdAndUp"
    id="myAccountLeftPanel"
    width="260"
    mobile-breakpoint="sm"
    left
    fixed
  >
    <!----- Headline ------>
    <headline-bar hide-divider class="mb-6">
      My account
    </headline-bar>

    <v-tabs vertical slider-color="secondary" slider-size="4" class="mt-n6">
      <template v-for="(item, i) in subMenuItems">
        <v-tab
          v-if="item.parent === 'My account'"
          :disabled="item.label !== 'Profile'"
          @click="changeRoute(item.path)"
          :key="i + 'tabMenu'"
          class="justify-start flex-wrap pl-6"
        >
          <span class="text-none text-body-1"> {{ item.label }} </span>
          <v-divider></v-divider>
        </v-tab>
      </template>
    </v-tabs>
  </v-navigation-drawer>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
#myAccountLeftPanel
	position: absolute
	z-index: 1

// FOR vertical tabs, right indicator
.v-tabs--vertical
	::v-deep .v-tabs-slider-wrapper
		left: unset !important
		right: 0

	::v-deep .v-divider
		bottom: 0
		left: 0
		position: absolute
		width: 100%
</style>
